var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongDizhibu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2v-.5a.5.5 0 00-.5.5H3zm0 12h-.5a.5.5 0 00.5.5V14zM3 2.5h10.5v-1H3v1zm10.5 0v11h1v-11h-1zm0 11H3v1h10.5v-1zm-10 .5V2h-1v12h1zm10-.5v1a1 1 0 001-1h-1zm0-11h1a1 1 0 00-1-1v1z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2v12.5",
    stroke: "#3F465C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5h1M2 8h1M2 11h1",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_dizhibu.071c377c.svg";
export { SvgTongyongDizhibu as ReactComponent };